export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/NoArtifactBgAsset-dac18ce91f83cd18d4991f2a361412fb.jpg";